// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/images/landing-page/icon_tel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/images/landing-page/icon_close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/images/landing-page/icon_menu.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
Theme Name: SO Grace Clinic Langing Page Theme
Author: 株式会社トータル・アシスト
*/
body,
button {
  font-family: "source-han-serif-japanese", serif;
  font-weight: 400;
  font-style: normal;
}

h1,
h2,
h3,
h4,
h5,
h6,
b,
strong,
em {
  font-family: "source-han-serif-japanese", serif;
  font-weight: 700;
  font-style: normal;
}

.sgc-contact-list__group {
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
}
@media screen and (min-width: 600px) {
  .sgc-contact-list__group {
    gap: 1.5rem;
  }
}
@media screen and (min-width: 1040px) {
  .sgc-contact-list__group {
    gap: 2.5rem;
  }
}
.sgc-contact-list__item {
  flex: 0 1 100%;
}
@media screen and (min-width: 600px) {
  .sgc-contact-list__item {
    flex: 1;
  }
}
.sgc-contact-list__item.type-icon {
  background-color: #2A9573;
  border-radius: 0.5rem;
  flex: 0 1 5rem;
}
.sgc-contact-list__item.type-icon:hover {
  background-color: #FFBF00;
  transition: all 0.5s 0s ease;
}

.sgc-modal__container {
  display: none;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.8); /* モーダル以外の背景 */
}
.sgc-modal__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #FFFFFF;
  padding: 1.5rem;
  border: 1px solid #737E84;
  width: 80%;
  max-width: 400px;
  position: relative;
  margin: 1rem auto;
  gap: 1rem;
}
@media screen and (min-width: 600px) {
  .sgc-modal__inner {
    margin: 15% auto;
    gap: 1.5rem;
  }
}
.sgc-modal__inner p {
  font-size: clamp(0.875rem, 0.75rem + 0.38vw, 1rem);
}
.sgc-modal__inner img {
  max-width: 300px;
  width: 100%;
}
.sgc-modal__inner .modal-close {
  border: 2px solid #FFBF00;
  border-radius: 999px;
  float: right;
  font-size: clamp(1rem, 0.75rem + 0.77vw, 1.25rem);
  padding: 0.75rem 1rem;
}
.sgc-modal__inner .modal-close:hover, .sgc-modal__inner .modal-close:focus {
  background-color: #FFBF00;
  transition: all 0.5s 0s ease;
  text-decoration: none;
  cursor: pointer;
}

.sgc-header {
  display: flex;
  flex-direction: column;
  margin-top: 0 !important;
}
.sgc-header__top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
}
@media screen and (min-width: 782px) {
  .sgc-header__top {
    justify-content: space-between;
  }
}
@media screen and (min-width: 1040px) {
  .sgc-header__top {
    padding: 1.5rem 2.5rem;
  }
}
.sgc-header__contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  position: fixed;
  bottom: 0;
  z-index: 9;
  border-top: 1px solid #C3CBCF;
  box-shadow: 0 0 1rem #737E84;
  width: 100%;
  background-color: #F3F7F9;
  padding: 1rem 0;
}
@media screen and (min-width: 600px) {
  .sgc-header__contact {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    border-top: none;
    box-shadow: none;
  }
}
@media screen and (min-width: 782px) {
  .sgc-header__contact {
    position: relative;
    justify-content: flex-end;
    gap: 0.5rem 1.5rem;
    background-color: transparent;
    padding: 0;
  }
}
.sgc-header__contact--hour {
  display: flex;
  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
@media screen and (min-width: 600px) {
  .sgc-header__contact--hour {
    flex-direction: column !important;
    gap: 0;
  }
}
.sgc-header__contact--buttons {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: space-evenly;
}
@media screen and (min-width: 782px) {
  .sgc-header__contact--buttons {
    gap: 0.5rem;
  }
}
.sgc-header__contact--title {
  font-size: 0.875rem;
}
.sgc-header__contact--time {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 1rem;
}
.sgc-header__contact--time .label-small {
  display: inline-block;
  border: 1px solid #3D464B;
  font-size: 0.625rem;
  line-height: 100%;
  padding: 0.25rem;
}
.sgc-header__contact--tel a {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.sgc-header__contact--tel a:before {
  content: "";
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-size: 1.25rem 1.25rem;
  background-color: #2A9573;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 0.75rem;
}
.sgc-header__contact--tel .button__multiple-lines {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 7px 1rem 7px 0.5rem;
}
@media screen and (min-width: 782px) {
  .sgc-header__contact--tel .button__multiple-lines {
    padding: 7px 1.5rem 7px 0.75rem;
  }
}
.sgc-header__contact--tel .button__multiple-lines--top {
  font-size: 0.5rem;
  font-weight: 700;
  line-height: 100%;
}
@media screen and (min-width: 782px) {
  .sgc-header__contact--tel .button__multiple-lines--top {
    font-size: 0.625rem;
  }
}
.sgc-header__contact--tel .button__multiple-lines--bottom {
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 100%;
}
@media screen and (min-width: 782px) {
  .sgc-header__contact--tel .button__multiple-lines--bottom {
    font-size: 1rem;
  }
}
.sgc-header__contact--social a {
  padding: 4px;
}
.sgc-header__contact--social a img {
  width: 2.5rem;
  height: 2.5rem;
}
.sgc-header__contact--mypage {
  flex: 0 1 100%;
  text-align: center;
}
@media screen and (min-width: 782px) {
  .sgc-header__contact--mypage {
    text-align: right;
  }
}
.sgc-header__contact--mypage a {
  font-size: 0.75rem;
  color: #3D464B !important;
  text-decoration: underline;
}
.sgc-header__bottom {
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 2px solid #A67C00;
}
.sgc-header__nav--container {
  display: none;
}
@media screen and (min-width: 782px) {
  .sgc-header__nav--container {
    display: flex;
  }
}
.sgc-header__nav--container.active {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: #F3F7F9;
  padding: 1rem;
}
.sgc-header__nav--group {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
@media screen and (min-width: 782px) {
  .sgc-header__nav--group {
    flex-direction: row;
    width: 782px;
  }
}
@media screen and (min-width: 1040px) {
  .sgc-header__nav--group {
    width: 1040px;
  }
}
.sgc-header__nav--item {
  background-color: #FFFFFF;
  border-left: none;
  border-bottom: 1px solid #BED9D0;
  width: 100%;
}
@media screen and (min-width: 782px) {
  .sgc-header__nav--item {
    background: linear-gradient(#FFFFFF, #F3F7F9, #DAE1E5);
    border-left: 1px solid #A67C00;
    width: 16.6666666667%;
  }
}
.sgc-header__nav--item:hover {
  background: linear-gradient(#FFFFFF, #F3F7F9);
}
.sgc-header__nav--item:last-child {
  border-right: none;
}
@media screen and (min-width: 782px) {
  .sgc-header__nav--item:last-child {
    border-right: 1px solid #A67C00;
  }
}
.sgc-header__nav--item a {
  display: inline-block;
  color: #A67C00;
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
  padding: 1rem 0;
  width: 100%;
  height: 48px;
}
.sgc-header__nav--item a:hover {
  color: #FFBF00;
}
.sgc-header__nav--close-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #3D464B;
  padding: 0.5rem;
  margin-bottom: 2.5rem;
  cursor: pointer;
}
@media screen and (min-width: 782px) {
  .sgc-header__nav--close-button {
    display: none;
  }
}
.sgc-header__nav--close-button:hover {
  background-color: #FFDC72;
}
.sgc-header__nav--close-button:before {
  content: "";
  display: inline-block;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  mask-size: 1.25rem 1.25rem;
  background-color: #3D464B;
  width: 1.25rem;
  height: 1.25rem;
}
.sgc-header__nav--mobile-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #A67C00;
  border: none !important;
  color: #FFFFFF;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  width: 100%;
  padding: 0.5rem 0;
  cursor: pointer;
}
.sgc-header__nav--mobile-button:before {
  content: "";
  display: inline-block;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  mask-size: 1.25rem 1.25rem;
  background-color: #FFFFFF;
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
}
@media screen and (min-width: 782px) {
  .sgc-header__nav--mobile-button {
    display: none;
  }
}

.sgc-header__logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
}

.sgc-header__logo--primary {
  width: 146px;
}

.sgc-header__logo--secondary {
  width: 121px;
  border-left: 1px solid #C3CBCF;
  margin-left: 16px;
  padding-left: 16px;
}

@media screen and (min-width: 782px) {
  .sgc-header__logo--primary {
    width: 165px;
  }
  .sgc-header__logo--secondary {
    width: 136px;
    margin-left: 16px;
    padding-left: 16px;
  }
}
@media screen and (min-width: 1040px) {
  .sgc-header__logo--primary {
    width: 220px;
  }
  .sgc-header__logo--secondary {
    width: 182px;
    margin-left: 24px;
    padding-left: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/sub.scss","webpack://./src/scss/00-global/_font.scss","webpack://./src/scss/03-organisms/_cta.scss","webpack://./src/scss/00-global/_dimensions.scss","webpack://./src/scss/00-global/_palette.scss","webpack://./src/scss/03-organisms/_global-header.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;CAAA;ACAA;;EAEE,+CAAA;EACA,gBAAA;EACA,kBAAA;ADMF;;ACHA;;;;;;;;;EASE,+CAAA;EACA,gBAAA;EACA,kBAAA;ADMF;;AErBE;EACE,WCkBO;EDjBP,eAAA;EACA,uBAAA;AFwBJ;AEtBI;EALF;IAMI,WCaK;EHYT;AACF;AEvBI;EATF;IAUI,WCaK;EHaT;AACF;AEvBE;EACE,cAAA;AFyBJ;AEvBI;EAHF;IAII,OAAA;EF0BJ;AACF;AExBI;EACE,yBEbU;EFcV,qBCXI;EDaJ,cAAA;AFyBN;AEvBM;EACE,yBE3BM;EF4BN,4BAAA;AFyBR;;AElBE;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA,EAAA,cAAA;AFqBJ;AElBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBEhCI;EFiCJ,eClCO;EDmCP,yBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,SC3CO;AH+DX;AElBI;EAbF;IAcI,gBAAA;IACA,WC5CK;EHiET;AACF;AElBI;EACE,kDAAA;AFoBN;AEjBI;EACE,gBAAA;EACA,WAAA;AFmBN;AEhBI;EACE,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,iDAAA;EACA,qBAAA;AFkBN;AEhBM;EAEE,yBEpFM;EFqFN,4BAAA;EACA,qBAAA;EACA,eAAA;AFiBR;;AK1GA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;AL6GF;AK3GE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBFKO;AHwGX;AK3GI;EAPF;IAQI,8BAAA;EL8GJ;AACF;AK5GI;EAXF;IAYI,sBAAA;EL+GJ;AACF;AKpGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WFrBM;EEsBN,eAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EACA,4BAAA;EACA,WAAA;EACA,yBD3BoB;EC4BpB,eAAA;ALsGJ;AKpGI;EAfF;IAgBI,mBAAA;IACA,eAAA;IACA,6BAAA;IACA,gBAAA;IACA,gBAAA;ELuGJ;AACF;AKrGI;EAvBF;IAwBI,kBAAA;IACA,yBAAA;IACA,kBAAA;IACA,6BAAA;IACA,UAAA;ELwGJ;AACF;AKtGI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WFpDI;AH4JV;AKtGM;EAPF;IAQI,iCAAA;IACA,MAAA;ELyGN;AACF;AKtGI;EACE,aAAA;EACA,mBAAA;EACA,WF/DI;EEgEJ,6BAAA;ALwGN;AKtGM;EANF;IAOI,WFnEE;EH4KR;AACF;AKtGI;EACE,mBFrEK;AH6KX;AKrGI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eF3EK;AHkLX;AKrGM;EACE,qBAAA;EACA,yBAAA;EACA,mBFnFG;EEoFH,iBAAA;EACA,gBFvFE;AH8LV;AKlGM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ALoGR;AKlGQ;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBDvGM;ECwGN,cF/FC;EEgGD,eFhGC;EEiGD,oBFrGC;AHyMX;AK/FQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YFjHA;EEkHA,4BAAA;ALiGV;AK/FU;EAPF;IAQI,+BAAA;ELkGV;AACF;AKhGU;EACE,iBFxHF;EEyHE,gBAAA;EACA,iBAAA;ALkGZ;AKhGY;EALF;IAMI,mBF5HH;EH+NT;AACF;AKhGU;EACE,mBF/HD;EEgIC,gBAAA;EACA,iBAAA;ALkGZ;AKhGY;EALF;IAMI,eFnIH;EHsOT;AACF;AK5FM;EACE,YAAA;AL8FR;AK7FQ;EACE,aFvIC;EEwID,cFxIC;AHuOX;AK1FI;EACE,cAAA;EACA,kBAAA;AL4FN;AK1FM;EAJF;IAKI,iBAAA;EL6FN;AACF;AK3FM;EACE,kBF/JG;EEgKH,yBAAA;EACA,0BAAA;AL6FR;AKxFE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gCAAA;ALyFJ;AKrFI;EACE,aAAA;ALuFN;AKrFM;EAHF;IAII,aAAA;ELwFN;AACF;AKtFM;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EAEA,yBDlMgB;ECmMhB,aFhMG;AHuRX;AKnFI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;ALqFN;AKnFM;EANF;IAOI,mBAAA;IACA,YF3NU;EHiThB;AACF;AKpFM;EAXF;IAYI,aF9NU;EHqThB;AACF;AKpFI;EACE,yBDjNE;ECkNF,iBAAA;EACA,gCAAA;EACA,WAAA;ALsFN;AKpFM;EANF;IAOI,sDAAA;IACA,8BAAA;IACA,qBAAA;ELuFN;AACF;AKrFM;EACE,6CAAA;ALuFR;AKpFM;EACE,kBAAA;ALsFR;AKpFQ;EAHF;IAII,+BAAA;ELuFR;AACF;AKpFM;EACE,qBAAA;EACA,cD5PW;EC6PX,kBF7OG;EE8OH,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ALsFR;AKpFQ;EACE,cDtQI;AJ4Vd;AKjFI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,eFvQI;EEwQJ,qBF7PK;EE8PL,eAAA;ALkFN;AKhFM;EAXF;IAYI,aAAA;ELmFN;AACF;AKjFM;EACE,yBD5RY;AJ+WpB;AKhFM;EACE,WAAA;EACA,qBAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBDnRY;ECoRZ,cFnRG;EEoRH,eFpRG;AHsWX;AK9EI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,yBD9Sa;EC+Sb,uBAAA;EACA,cD9RE;EC+RF,eFnSK;EEoSL,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AL+EN;AK7EM;EACE,WAAA;EACA,qBAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBD3SA;EC4SA,cF9SG;EE+SH,eF/SG;EEgTH,oBFtTE;AHqYV;AK5EM;EA3BF;IA4BI,aAAA;EL+EN;AACF;;AK1EA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,MAAA;AL6EF;;AK3EA;EACE,YAAA;AL8EF;;AK5EA;EACE,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AL+EF;;AK7EA;EACE;IACE,YAAA;ELgFF;EK7EA;IACE,YAAA;IACA,iBAAA;IACA,kBAAA;EL+EF;AACF;AK7EA;EACE;IACE,YAAA;EL+EF;EK5EA;IACE,YAAA;IACA,iBAAA;IACA,kBAAA;EL8EF;AACF","sourcesContent":["/* \nTheme Name: SO Grace Clinic Langing Page Theme\nAuthor: 株式会社トータル・アシスト\n*/\n\n// @forward \"./_mixins/\";\n// @forward \"./00-global/\";\n// @forward \"./01-atoms/\";\n// @forward \"./02-molecules/\";\n@forward \"./03-organisms/cta\";\n@forward \"./03-organisms/global-header\";\n// @forward \"./04-templates/\";\n// @forward \"./05-pages/\";\n// @forward \"./06-overrides/\";\n","body,\nbutton {\n  font-family: \"source-han-serif-japanese\", serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nb,\nstrong,\nem {\n  font-family: \"source-han-serif-japanese\", serif;\n  font-weight: 700;\n  font-style: normal;\n}\n","@use \"../00-global\" as *;\n\n.sgc-contact-list {\n  &__group {\n    gap: $num-24px;\n    flex-wrap: wrap;\n    justify-content: center;\n\n    @media screen and (min-width: $screen-small) {\n      gap: $num-24px;\n    }\n\n    @media screen and (min-width: $screen-large) {\n      gap: $num-40px;\n    }\n  }\n\n  &__item {\n    flex: 0 1 100%;\n\n    @media screen and (min-width: $screen-small) {\n      flex: 1;\n    }\n    \n    &.type-icon {\n      background-color: $col-secondary;\n      border-radius: $num-8px;\n\n      flex: 0 1 $num-80px;\n\n      &:hover {\n        background-color: $col-primary;\n        transition: all 0.5s 0s ease;\n      }\n    }\n  }\n}\n\n.sgc-modal {\n  &__container {\n    display: none;\n    position: fixed;\n    z-index: 10;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0,0,0,0.8); /* モーダル以外の背景 */\n  }\n\n  &__inner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: $white;\n    padding: $num-24px;\n    border: 1px solid $col-tertiary;\n    width: 80%;\n    max-width: 400px;\n    position: relative;\n    margin: $num-16px auto;\n    gap: $num-16px;\n\n    @media screen and (min-width: $screen-small) {\n      margin: 15% auto;\n      gap: $num-24px;\n    }\n\n\n    p {\n      font-size: clamp($num-14px, 0.75rem + 0.38vw, $num-16px);\n    }\n\n    img {\n      max-width: 300px;\n      width: 100%;\n    }\n\n    .modal-close {\n      border: 2px solid $col-primary;\n      border-radius: 999px;\n      float: right;\n      font-size: clamp($num-16px, 0.75rem + 0.77vw, $num-20px);\n      padding: $num-12px $num-16px;\n\n      &:hover,\n      &:focus {\n        background-color: $col-primary;\n        transition: all 0.5s 0s ease;\n        text-decoration: none;\n        cursor: pointer;\n      }\n    }\n  }\n}\n","$root-size: 16;\n\n$screen-xsmall:   520px !default; // Mobile\n$screen-small:    600px !default; // Mini Tablet\n$screen-medium:   782px !default; // Tablet - was 768px\n$screen-large:    1040px !default; // Desktop - was 960px\n$screen-xlarge:   1460px !default; // Large Desktop - to be deprecated\n\n$screen-smartphone-portrait: 601px !default;\n\n$max-width-s: calc(640 / $root-size * 1rem);\n$max-width-m: calc(960 / $root-size * 1rem);\n$max-width-l: calc(1040 / $root-size * 1rem);\n\n$num-4px: 0.25rem;\n$num-8px: 0.5rem;\n$num-10px: 0.625rem;\n$num-12px: 0.75rem;\n$num-14px: 0.875rem;\n$num-16px: 1rem;\n$num-18px: 1.125rem;\n$num-20px: 1.25rem;\n$num-24px: 1.5rem;\n$num-28px: 1.75rem;\n$num-32px: 2rem;\n$num-36px: 2.25rem;\n$num-40px: 2.5rem;\n$num-48px: 3rem;\n$num-56px: 3.5rem;\n$num-64px: 4rem;\n$num-72px: 4.5rem;\n$num-80px: 5rem;\n$num-96px: 6rem;\n","// Brand Colours\n$col-primary-lightest: #FFFCF1;\n$col-primary-lighter: #FEEEBD;\n$col-primary-light: #FFDC72;\n$col-primary: #FFBF00;\n$col-primary-dark: #A67C00;\n$col-primary-darker: #673607;\n\n$col-primary-extra: #F3E7C4;\n\n$col-secondary-lighter: #DDF1EA;\n$col-secondary-light: #BED9D0;\n$col-secondary: #2A9573;\n$col-secondary-dark: #005E40;\n$col-secondary-darker: #022A01;\n\n$col-tertiary-lightest: #F3F7F9;\n$col-tertiary-lighter: #DAE1E5;\n$col-tertiary-light: #C3CBCF;\n$col-tertiary: #737E84;\n$col-tertiary-dark: #3D464B;\n$col-tertiary-darker: #1B2022;\n\n$white: #FFFFFF;\n$blue: #1167D9;\n\n$col-bronze: #E6D19C;\n\n$col-beige-light: #F3E7C4;\n$col-beige: #B6986E;\n\n// Font Colours\n$col-heading: $col-tertiary-darker;\n$col-copy: $col-tertiary-dark;\n$col-quiet: $col-tertiary;\n\n// UI Colours\n$col-border: $col-tertiary-light;\n$col-background: $col-tertiary-lighter;\n$col-label: $col-tertiary-darker;\n// $col-checked: $col-primary;\n\n// Link\n// $col-button-default: $col-secondary-darker;\n// $col-checked: $col-primary-dark;\n\n// Third party\n$col-line: #06C755;\n","@use \"../00-global\" as *;\n\n.sgc-header {\n  display: flex;\n  flex-direction: column;\n  margin-top: 0 !important;\n  \n  &__top {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: $num-12px;\n\n    @media screen and (min-width: $screen-medium) {\n      justify-content: space-between;\n    }\n\n    @media screen and (min-width: $screen-large) {\n      padding: $num-24px $num-40px;\n    }\n  }\n\n  // &__logo {\n  //   width: clamp(11.25rem, 3.672rem + 15.5vw, 13.75rem);\n\n  //   p {\n  //     margin: 0;\n  //   }\n  // }\n\n  &__contact {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    gap: $num-8px;\n    position: fixed;\n    bottom: 0;\n    z-index: 9;\n    border-top: 1px solid $col-tertiary-light;\n    box-shadow: 0 0 $num-16px $col-tertiary;\n    width: 100%;\n    background-color: $col-tertiary-lightest;\n    padding: $num-16px 0;\n\n    @media screen and (min-width: $screen-small) {\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: space-evenly;\n      border-top: none;\n      box-shadow: none;\n    }\n\n    @media screen and (min-width: $screen-medium) {\n      position: relative;\n      justify-content: flex-end;\n      gap: $num-8px $num-24px;\n      background-color: transparent;\n      padding: 0;\n    }\n\n    &--hour {\n      display: flex;\n      flex-direction: row !important;\n      align-items: center;\n      justify-content: center;\n      gap: $num-8px;\n\n      @media screen and (min-width: $screen-small) {\n        flex-direction: column !important;\n        gap: 0;\n      }\n    }\n\n    &--buttons {\n      display: flex;\n      flex-direction: row;\n      gap: $num-8px;\n      justify-content: space-evenly;\n\n      @media screen and (min-width: $screen-medium) {\n        gap: $num-8px;\n      }\n    }\n\n    &--title {\n      font-size: $num-14px;\n    }\n\n    &--time {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      font-size: $num-16px;\n\n      .label-small {\n        display: inline-block;\n        border: 1px solid $col-copy;\n        font-size: $num-10px;\n        line-height: 100%;\n        padding: $num-4px;\n      }\n    }\n\n    &--tel {\n      a {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n\n        &:before {\n          content: \"\";\n          mask-image: url(\"/images/landing-page/icon_tel.svg\");\n          mask-size: $num-20px $num-20px;\n          background-color: $col-secondary;\n          width: $num-20px;\n          height: $num-20px;\n          margin-left: $num-12px;\n        }\n      }\n\n      .button {\n        &__multiple-lines {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: $num-4px;\n          padding: 7px $num-16px 7px $num-8px;\n\n          @media screen and (min-width: $screen-medium) {\n            padding: 7px $num-24px 7px $num-12px;\n          }\n\n          &--top {\n            font-size: $num-8px;\n            font-weight: 700;\n            line-height: 100%;\n\n            @media screen and (min-width: $screen-medium) {\n              font-size: $num-10px;\n            }\n          }\n\n          &--bottom {\n            font-size: $num-14px;\n            font-weight: 700;\n            line-height: 100%;\n\n            @media screen and (min-width: $screen-medium) {\n              font-size: $num-16px;\n            }\n          }\n        }\n      }\n    }\n\n    &--social {\n      a {\n        padding: 4px;\n        img {\n          width: $num-40px;\n          height: $num-40px;\n        }\n      }\n    }\n\n    &--mypage {\n      flex: 0 1 100%;\n      text-align: center;\n\n      @media screen and (min-width: $screen-medium) {\n        text-align: right;\n      }\n\n      a {\n        font-size: $num-12px;\n        color: $col-copy !important;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  &__bottom {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n\n    border-bottom: 2px solid $col-primary-dark;\n  }\n\n  &__nav {\n    &--container {\n      display: none;\n\n      @media screen and (min-width: $screen-medium) {\n        display: flex;\n      }\n\n      &.active {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 999;\n\n        background-color: $col-tertiary-lightest;\n        padding: $num-16px;\n      }\n    }\n\n    &--group {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      width: 100%;\n      \n      @media screen and (min-width: $screen-medium) {\n        flex-direction: row;\n        width: $screen-medium;\n      }\n\n      @media screen and (min-width: $screen-large) {\n        width: $screen-large;\n      }\n    }\n\n    &--item {\n      background-color: $white;\n      border-left: none;\n      border-bottom: 1px solid $col-secondary-light;\n      width: 100%;\n      \n      @media screen and (min-width: $screen-medium) {\n        background: linear-gradient($white, $col-tertiary-lightest, $col-tertiary-lighter);\n        border-left: 1px solid $col-primary-dark;\n        width: calc(100% / 6);\n      }\n\n      &:hover {\n        background: linear-gradient($white, $col-tertiary-lightest);\n      }\n\n      &:last-child {\n        border-right: none;\n\n        @media screen and (min-width: $screen-medium) {\n          border-right: 1px solid $col-primary-dark;\n        }\n      }\n      \n      a {\n        display: inline-block;\n        color: $col-primary-dark;\n        font-size: $num-20px;\n        font-weight: 700;\n        text-align: center;\n        padding: $num-16px 0;\n        width: 100%;\n        height: 48px;\n\n        &:hover {\n          color: $col-primary;\n        }\n      }\n    }\n\n    &--close-button {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n\n      border: 1px solid $col-copy;\n      padding: $num-8px;\n      margin-bottom: $num-40px;\n      cursor: pointer;\n\n      @media screen and (min-width: $screen-medium) {\n        display: none;\n      }\n\n      &:hover {\n        background-color: $col-primary-light;\n      }\n\n      &:before {\n        content: \"\";\n        display: inline-block;\n        mask-image: url(\"/images/landing-page/icon_close.svg\");\n        mask-size: $num-20px $num-20px;\n        background-color: $col-copy;\n        width: $num-20px;\n        height: $num-20px;\n      }\n    }\n\n    &--mobile-button {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: center;\n\n      background-color: $col-primary-dark;\n      border: none !important;\n      color: $white;\n      font-size: $num-16px;\n      font-weight: 700;\n      text-align: center;\n      width: 100%;\n      padding: $num-8px 0;\n      cursor: pointer;\n\n      &:before {\n        content: \"\";\n        display: inline-block;\n        mask-image: url(\"/images/landing-page/icon_menu.svg\");\n        mask-size: $num-20px $num-20px;\n        background-color: $white;\n        width: $num-20px;\n        height: $num-20px;\n        margin-right: $num-8px;\n      }\n\n      @media screen and (min-width: $screen-medium) {\n        display: none;\n      }\n    }\n  }\n}\n\n.sgc-header__logo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n}\n.sgc-header__logo--primary {\n  width: 146px;\n}\n.sgc-header__logo--secondary {\n  width: 121px;\n  border-left: 1px solid #C3CBCF;\n  margin-left: 16px;\n  padding-left: 16px;\n}\n@media screen and (min-width: 782px) {\n  .sgc-header__logo--primary {\n    width: 165px;\n  }\n  \n  .sgc-header__logo--secondary {\n    width: 136px;\n    margin-left: 16px;\n    padding-left: 16px;\n  }\n}\n@media screen and (min-width: 1040px) {\n  .sgc-header__logo--primary {\n    width: 220px;\n  }\n  \n  .sgc-header__logo--secondary {\n    width: 182px;\n    margin-left: 24px;\n    padding-left: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
